module.exports = __webpack_public_path__ + "img/mexico863.a41af61c.jpg";